import * as React from "react";
const SvgSendBtn = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 12H18V8M5 12L9.01907 16M5 12L9.01907 8", stroke: "#C7D0D9", strokeWidth: 1.25 }));
export default SvgSendBtn;
